/* eslint-disable @typescript-eslint/no-unused-vars */
import { yupResolver } from '@hookform/resolvers/yup';
import { useEffect } from 'react';
import { useForm, useWatch } from 'react-hook-form';
import { Autocomplete, Button, Input, ScrollableTabPanel, Progress } from '../../../components';
import { Condominium } from '../../../entities';
import { Locker, LockerVendor } from '../../../entities/locker.entity';
import { LockerForm, schema } from '../../../validations/locker.validation';

interface LockerPanelProps {
  locker: Locker;
  condominiums: Condominium[];
  visible: boolean;
  inProgress: boolean;
  onClickClose: () => void;
  onSubmit: (value: Locker) => void;
  onSync: (value: Locker) => void;
}

const VendorOptions: { label: string; value: LockerVendor }[] = [
  { label: 'EntregaAli', value: LockerVendor.EntregaAli },
  { label: 'MeuLocker', value: LockerVendor.MeuLocker },
  { label: 'CliqueRetire', value: LockerVendor.CliqueRetire },
];

export const LockerPanel = ({
  locker,
  visible,
  condominiums,
  inProgress,
  onClickClose,
  onSubmit,
  onSync,
}: LockerPanelProps): JSX.Element => {
  const {
    control,
    formState: { errors, isSubmitting },
    setValue,
    getValues,
    register,
    handleSubmit,
    reset,
  } = useForm<LockerForm>({
    resolver: yupResolver(schema),
    mode: 'onChange',
  });

  useEffect(() => {
    reset({
      ...locker,
      lockerId: locker.lockerId || '',
    });
  }, [locker, reset]);
  const condominiumId = useWatch({ control, name: 'condominiumId' });
  const vendor = useWatch({ control, name: 'vendor' });

  return (
    <ScrollableTabPanel
      mustConfirm
      mustConfirmContent="Deseja continuar a atualização do locker? "
      title="Dados do armário"
      visible={visible}
      onClickClose={onClickClose}
      onClickSubmit={handleSubmit(() => onSubmit({ ...locker, ...getValues() }))}
      loading={false}
    >
      <Input
        label="Id do parceiro"
        placeholder="Ex: #Entregali-01"
        validationRegister={register('lockerId')}
        error={Boolean(errors.lockerId)}
        helperText={errors.lockerId?.message || ' '}
      />
      <Autocomplete
        label="Selecione o parceiro"
        placeholder="Ex: Entregali"
        value={VendorOptions.find((opt) => opt.value === vendor) || null}
        options={VendorOptions}
        getOptionLabel={(opts) => opts.label}
        onChange={(e, value) => setValue('vendor', value?.value)}
        error={Boolean(errors.vendor)}
        helperText={errors.vendor?.message || ' '}
      />
      <Autocomplete
        label="Selecione o condomínio"
        placeholder="Ex: SKR"
        value={condominiums.find((cond) => cond.id === condominiumId) || null}
        options={condominiums}
        onChange={(e, value) => {
          setValue('condominiumId', value?.id);
        }}
        getOptionLabel={(cond) => cond.name}
        error={Boolean(errors.condominiumId)}
        helperText={errors.condominiumId?.message || ' '}
      />

      {vendor === LockerVendor.CliqueRetire ? (
        <>
          <Button variant="text" color="primary" onClick={() => onSync(locker)}>
            Sincronizar informações
          </Button>
          {inProgress ? <Progress /> : <></>}
        </>
      ) : (
        <></>
      )}
    </ScrollableTabPanel>
  );
};

export default LockerPanel;
